import { render } from "./NrzPage.vue?vue&type=template&id=3b8f73ba&scoped=true"
import script from "./NrzPage.vue?vue&type=script&lang=js"
export * from "./NrzPage.vue?vue&type=script&lang=js"

import "./NrzPage.vue?vue&type=style&index=0&id=3b8f73ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8f73ba"]])

export default __exports__